import React from 'react';
import { createRoot } from 'react-dom/client';

import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css';

import './styles/theme.css';
import './styles/main.css';
import './index.css';
import App from './App';
import $ from 'jquery/dist/jquery.js';
import * as Sentry from '@sentry/browser';

window.jQuery = $;

// Sentry.init({ dsn: 'https://d53c6cdad774442690ac6a822fecb233@o402604.ingest.sentry.io/5264059' });


const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then(regs => regs.forEach(r => r.unregister()));
}
